import { type ReactNode } from "react";

import { ChatHeader } from "../../Chat/ChatHeader";
import { useChannelMetadata } from "../hooks/useChannelMetadata";

interface ClipboardGuidesChatHeaderTitleProps {
  onBack: () => void;
  rightAction?: ReactNode;
}

export function ClipboardGuidesChatHeaderTitle(
  props: ClipboardGuidesChatHeaderTitleProps
): JSX.Element {
  const { onBack, rightAction } = props;
  const metadata = useChannelMetadata();

  const workplaceName = metadata?.facilityName;

  return (
    <ChatHeader
      title={workplaceName ? `Community at ${workplaceName}` : "Community"}
      subtitle="Ask the regulars"
      rightAction={rightAction}
      onBack={onBack}
    />
  );
}
